import { sortBy } from 'lodash-es';
import type { z } from 'zod';
import type { BudgetAgendaSortOrderDataModel } from '../components/BudgetAgendaSortOrderModal';
import type { ExpenditurePurposesModel, RevenueNaturesModel } from '../models';

const getBudgetAgendaSortOrderDataSourceItem = (
  data:
    | z.infer<typeof RevenueNaturesModel.element>
    | z.infer<typeof ExpenditurePurposesModel.element>,
) => ({
  id: data.id,
  code: data.code,
  name: data.name,
  level: data.level,
  startYear: data.startYear ?? null,
  endYear: data.endYear ?? null,
  budgetAgendaSortOrder:
    typeof data.budgetAgendaSortOrder === 'number'
      ? data.budgetAgendaSortOrder
      : null,
  createdAt: data.createdAt,
  updatedAt: data.updatedAt,
});

export const getBudgetAgendaSortOrderDataSource = ({
  data,
  budgetAgendaSortOrderModalState,
}: {
  data:
    | z.infer<typeof RevenueNaturesModel>
    | z.infer<typeof ExpenditurePurposesModel>
    | undefined;
  budgetAgendaSortOrderModalState: {
    accountingId: string | null;
    level: number | null;
    upperId: string | null;
  };
}): BudgetAgendaSortOrderDataModel => {
  if (
    !data ||
    budgetAgendaSortOrderModalState.level === null ||
    (!budgetAgendaSortOrderModalState.accountingId &&
      !budgetAgendaSortOrderModalState.upperId)
  ) {
    return [];
  }

  const targetItems = () => {
    if (budgetAgendaSortOrderModalState.level === 1) {
      return data.filter((d) => {
        return (
          d.level === 1 &&
          d.accountingId === budgetAgendaSortOrderModalState.accountingId
        );
      });
    }

    return data.filter((d) => {
      return (
        d.upperId === budgetAgendaSortOrderModalState.upperId &&
        d.level === budgetAgendaSortOrderModalState.level
      );
    });
  };

  const sortedNonNullItems = sortBy(
    targetItems().filter((d) => d.budgetAgendaSortOrder !== null),
    'budgetAgendaSortOrder',
  ).map((d) => getBudgetAgendaSortOrderDataSourceItem(d));
  const sortedNullItems = sortBy(
    targetItems().filter((d) => d.budgetAgendaSortOrder === null, 'code'),
  ).map((d) => getBudgetAgendaSortOrderDataSourceItem(d));

  return [...sortedNonNullItems, ...sortedNullItems];
};
